import React, { useEffect, useState } from "react";
import { fetch } from "../actions";
import { connect } from "react-redux";
import { RedoOutlined } from "@ant-design/icons";
import { atualizarDados } from "../containers/Auth/AuthApi";
import { useSave } from "./Hooks/Conexao";
import Mensagens from "./Mensagens";

function BtnAtualizarDados({ onAtualizar, ...props }) {
  const [atualizar, loading] = useSave(() => atualizarDados(props.fetch), res => {
    if (!!onAtualizar)
      onAtualizar(res);

    Mensagens.showSucesso("Atualizado com sucesso!");
  });

  useEffect(() => {
    if (props?.setLoading)
      props.setLoading(loading);
  }, [loading]);

  return <RedoOutlined onClick={atualizar} style={{ fontSize: 25, margin: "0 10px", ...props.style }} spin={loading}
  />;
}

export default connect(null, { fetch })(BtnAtualizarDados);